// import './App.css';
import React, { useState } from 'react';
import { Header_2026, Footer_2026, Blogs_2026 } from '../container';


function SecIdeas() {


  return (
    <div id='top_blogs' className="_nghost-ng-c21878618">
      <Header_2026/>
      <Blogs_2026/>
      <Footer_2026/>
    </div>
  );
}

export default SecIdeas;
